module.exports = __webpack_public_path__ + "static/media/fly0075.0ac4e4f0.webp";